import { FC } from 'react';
import { useSelector, useDispatch } from '@cbridge-utils/react-redux';
import { FilterBlockItemBase, IFilterItemRendererProps } from '@cbridge-tools/filters-panel';
import { ClientSymbolFilter } from '@cbridge-packages/symbol-client';
import { SymbolMappingFilterAction } from '../../symbolMappingFilter.action';
import { symbolMappingFilterItemPropsSelector } from './SymbolMappingFilterItem.selector';

export const SymbolMappingFilterItem: FC<IFilterItemRendererProps> = (props) => {
  const { item } = props;
  const filterOption = item.value as ClientSymbolFilter;

  const isSelected = useSelector(symbolMappingFilterItemPropsSelector, { optionId: filterOption });
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(SymbolMappingFilterAction.setFilter(filterOption));
  };

  return (
    <FilterBlockItemBase
      item={item}
      depth={0}
      isSelected={isSelected}
      onClick={handleClick}
    />
  );
};
